import React from 'react';
import Nav        from './components/Nav/Nav';
import Hero       from './components/Hero/Hero';
import About      from './components/About/About';
import Experience from './components/Experience/Experience';
import Skills     from './components/Skills/Skills';
import Projects   from './components/Projects/Projects';
import Contact    from './components/Contact/Contact';
import Footer     from './components/Footer/Footer';

export default function App(): React.ReactElement {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
